import { freeze, merge } from 'icepick';
import { type InlineJoinState } from './types';
import { type AnyAction } from 'redux';
import { SET } from '../create-space/actions';
import { INLINE_JOIN_CONFLUENCE, INLINE_JOIN_FAILED } from '../../actions';

const initialState: InlineJoinState = freeze({
	isJoinPending: false,
});

export default (state: InlineJoinState = initialState, action: AnyAction): InlineJoinState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		case INLINE_JOIN_CONFLUENCE:
			return merge(state, {
				isJoinPending: true,
			});
		case INLINE_JOIN_FAILED:
			return merge(state, {
				isJoinPending: false,
			});
		default:
			return state;
	}
};
